import { FAIconName } from '@equip.health/ui';

export const TechOpsToasts = {
  submitJob: {
    error: () => ({
      id: 'submit-job-error',
      icon: FAIconName.exclamationTriangleRegular,
      text: "We're sorry, we were unable to submit the job. Please try again",
      variant: 'critical' as const,
    }),
  },
  pollJob: {
    notFound: (jobKey: string) => ({
      id: 'poll-job-not-found',
      icon: FAIconName.exclamationTriangleRegular,
      text: `Job with the key ${jobKey} does not exist`,
      variant: 'critical' as const,
    }),
    error: (jobKey: string) => ({
      id: 'poll-job-error',
      icon: FAIconName.exclamationTriangleRegular,
      text: `Unexpected error. Couldn't fetch status for job with the key ${jobKey}`,
      variant: 'critical' as const,
    }),
  },
  refreshJob: {
    error: () => ({
      id: 'refresh-job-error',
      icon: FAIconName.exclamationTriangleRegular,
      text: 'Unable to refresh latest job. Please try again',
      variant: 'critical' as const,
    }),
  },
};
